import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { RippleModule } from 'primeng/ripple';
import { versions } from '../../../../../../environments/versions';
import { IconKey } from '../../../../../../whitelabel/icon-key.enum';
import { ButtonComponent } from '../../../../../osp-ui/components/button/button/button.component';
import { OverlayPanelComponent } from '../../../../../osp-ui/components/overlay/overlay-panel/overlay-panel.component';
import { TooltipDirective } from '../../../../../osp-ui/components/overlay/tooltip/tooltip.directive';
import { IconPipe } from '../../../../../shared/pipes/icon.pipe';
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'osp-help-overlay',
  standalone: true,
  imports: [
    OverlayPanelComponent,
    ButtonComponent,
    RippleModule,
    TranslateModule,
    TooltipDirective,
    IconPipe,
    AccordionModule,
    NgClass,
  ],
  templateUrl: './help-overlay.component.html',
  styleUrls: ['./help-overlay.component.scss', '../topbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpOverlayComponent {
  @ViewChild('op') overlayPanel!: OverlayPanelComponent;

  constructor(private languageService: LanguageService) {}

  readonly commit = versions.commit;
  readonly version = versions.tag;
  readonly IconKey = IconKey;
  readonly link =
    'https://www.onestop-pro.com/' +
    // '/de/#/release-notes#' + // '/en/#/release-notes-en#' for english
    this.languageService.getInstant('modules.navigation.appInfo.linkReleaseNotesUrl') +
    '?password=' +
    (
      (new Date(
        new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate(), 1, 0, 0),
      ).getTime() /
        100000) *
      (new Date(
        new Date(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate(), 1, 0, 0),
      ).getTime() /
        100000)
    )
      .toString()
      .split('')
      .reverse()
      .join('');

  onToggle(event: Event | PointerEvent): void {
    if (!this.overlayPanel) {
      return;
    }
    this.overlayPanel.toggle(event);
  }

  hideOverlay(): void {
    if (this.overlayPanel) {
      this.overlayPanel.overlayPanel.hide();
    }
  }

  onReleaseInfoClick(): void {
    const win = window.open(this.link, '__blank');
    win?.focus();
    this.hideOverlay();
  }
}
